import { LOGIN, LOGOUT, LANG, SEARCH, LOGINMODAL, ISSIGNIN,ISDEVELOPERLOGIN } from "./actionTypes";

// Asynchronous action to fetch the pkgid and log in the user
export const loginUser = ({ displayName, email, uid, packageid , status, temp_pkgid, temp_id }) => {
  return {
    type: LOGIN,
    payload: { displayName, email, uid, packageid , status,  temp_pkgid, temp_id},
  };
};

export const loginDeveloper = ({ developername, developeremail, developerrole, developeruid  }) => {
  return {
    type: ISDEVELOPERLOGIN,
    payload: { developername, developeremail,developerrole , developeruid},
  };
};

export const logoutUser = () => {
  return {
    type: LOGOUT,
  };
};

export const language = (lang) => {
  return {
    type: LANG,
    payload: { lang },
  };
};

export const searchByHeader = (val) => {
  return {
    type: SEARCH,
    payload: { val },
  };
};

export const loginModal = (val) => {
  return {
    type: LOGINMODAL,
    payload: { val },
  };
};

export const isSigninModel = (val) => {
  return {
    type: ISSIGNIN,
    payload: { val },
  };
};
